import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { serializeObject } from 'utils/Helpers'
import { actions as TrackingActions } from 'app/modules/tracking'
import LoadingDots from 'components/shared/LoadingDots'
import ConnectLink from './ConnectLink'
import Connected from './Connected'

import withNotifications from 'components/shared/notifications'
import { createAccessToken, fetchIntegrationStates, updateIntegrationState } from 'app/modules/integrations/actions'
import { connectionsRoot, didCreateAccessToken, failedCreateAccessToken } from 'app/modules/integrations/selectors'


const OAuthFailed = "Uh oh! Something happened before we could connect. Try again!"

export function makeOauthUrl(oauthLink, oauthQueryParams, oauthRawParams) {
  const params = serializeObject(oauthQueryParams)
  const extraParams = oauthRawParams || ''
  return `${oauthLink}?${params}${extraParams}`
}

class OauthConnector extends Component {
  static propTypes = {
    trackingPayload: PropTypes.shape({
      context: PropTypes.string
    }),
  }

  constructor(props) {
    super(props)

    this.state = {
      updating: false
    }
  }

  componentWillMount() {
    if (!!this.props.integrationStates && this.props.integrationStates[this.props.integrationId]) {
      this.props.onIntegrationConnected && this.props.onIntegrationConnected()
    }
  }

  componentWillReceiveProps({ integrationStates, failedCreateAccessToken, integrationId, actions, trackingPayload }) {
    const currentIntegrationStates = this.props.integrationStates

    if (currentIntegrationStates[integrationId] !== integrationStates[integrationId]) {
      this.setState({ updating: false })
      if (integrationStates[integrationId]) {
        this.setState({ updating: false })
        this.notifySuccess()
      }
    }

    if (failedCreateAccessToken) {
      this.setState({ updating: false })
      this.props.notifications.error("We could not connect. Please check your input and try again.")
    }
  }

  handleClose = () => {
    if (this.state.updating) {
      this.props.actions.fetchIntegrationStates()
      this.setState({ updating: false })
    }
  }

  handleConnect = () => {
    const { oauthLink, oauthQueryParams, oauthRawParams, onConnecting } = this.props
    const url = makeOauthUrl(oauthLink, oauthQueryParams, oauthRawParams)

    if (onConnecting) {
      onConnecting()
    }

    this.popUp({
      path: url,
      onClose: this.handleClose,
      onMessage: (e) => {
        const integrationStatus = e.data.status
        if (integrationStatus === 'success') {
          this.props.actions.fetchIntegrationStates()
          this.notifySuccess()
        } else if (integrationStatus === 'failed' || integrationStatus === 'failure') {
          this.notifyFailure(e.data.errormessage || OAuthFailed)
        }
      }
    })
    this.setState({ updating: true })
  }

  handleDisconnect = () => {
    const { integrationId, actions } = this.props
    actions.updateIntegrationState({ integration: integrationId, connected: false })
    actions.track('Integration Disconnected', { integration: integrationId, connected: false })
    this.setState({ updating: true })
  }

  popUp({ path, onClose, onMessage, windowName, windowOptions }) {
    windowName = windowName || 'ConnectWithOAuth' // should not include space for IE
    windowOptions = windowOptions || 'location=0,status=0,width=800,height=600'
    onClose = onClose || (() => {
      window.location.reload()
    })
    const _oauthWindow = window.open(path, windowName, windowOptions)
    const _oauthInterval = window.setInterval(() => {
      if (_oauthWindow.closed) {
        window.clearInterval(_oauthInterval)
        onClose()
      }
    }, 1000)
    window.addEventListener('message', (e) => {
      return onMessage && onMessage(e)
    })
    return _oauthWindow
  }

  getSuccessMessage(service) {
    return `${_.capitalize(service)} was successfully connected!`
  }

  notifySuccess = () => {
    const { integrationId, actions, notifications, trackingPayload, onIntegrationConnected } = this.props

    actions.track('Integration Connected', { integration: integrationId, connected: true, ...trackingPayload })
    notifications.success(this.getSuccessMessage(integrationId))
    onIntegrationConnected && onIntegrationConnected()
  }

  notifyFailure = (errormessage) => {
    this.props.notifications.error(errormessage)
  }

  renderConnectionLinks = () => {
    const { integrationStates, integrationId, connectorType, connectorClass, label, buttonType, tooltipText } = this.props
    if (integrationStates && !!integrationStates[integrationId]) {
      return <Connected
        integrationId={integrationId}
        handleDisconnect={this.handleDisconnect}
      />
    } else {
      return <ConnectLink
        handleConnect={this.handleConnect}
        connectorClass={connectorClass}
        connectorType={connectorType}
        label={label}
        buttonType={buttonType}
        tooltipText={tooltipText}
      />
    }
  }

  render() {
    const { updating } = this.state
    return (
      <div>
        {updating
          ? <div style={{ maxWidth: '50px' }}><LoadingDots /></div>
          : this.renderConnectionLinks()}
      </div>
    )
  }
}

const mapStateToProps = (state, props) => {
  const integrationName = props.integrationId || ''

  return {
    integrationStates: connectionsRoot(state),
    accessTokenCreationFailed: failedCreateAccessToken(state, integrationName)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators({
      track: TrackingActions.track,
      createAccessToken,
      fetchIntegrationStates,
      updateIntegrationState
    }, dispatch)
  }
}


export default withNotifications(connect(
  mapStateToProps,
  mapDispatchToProps
)(OauthConnector))



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/components/OauthConnector.js